/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as videoActions from '../../actions/videoActions';
import MetaTags from 'react-meta-tags';
import ArtistService from '../../services/artistService.js';
import VideoItem from '../common/VideoItem';
import * as imageUtils from '../../utils/imageUtils';
import NotFound from '../common/NotFound';
import PageLoading from '../common/PageLoading';

class VideoPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.videoID = props.match.params.id;
        this.getDescription = this.getDescription.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.state = {
            videoStatus: null
        };
    }

    componentWillMount() {
        this.setState({ videoStatus: 'LOADING' });
        this.props.actions.getVideo(this.videoID)
            .then(_ => {
                this.setState({ videoStatus: 'LOADED' });
            })
            .catch(err => {
                this.setState({ videoStatus: 'FAILED' });
            });
    }

    getTitle(includeLink = false) {       
        if(this.props.mainVideo) {
            const mainVideo = this.props.mainVideo;
            if(includeLink) {
                return <span>{`Watch the video for ${this.props.mainVideo.Name} by `}<Link to={`/${this.props.roleUsername}`}>{this.props.roleDisplayName}</Link></span>;
            }
            else {
                return `Watch the video for ${this.props.mainVideo.Name} by ${this.props.roleDisplayName}`;
            }
        }
        else {
            return '';
        }
    }

    getDescription() {
        if(this.props.mainVideo) {   
            return `Check out the video - '${this.props.mainVideo.Name}' by ${this.props.roleDisplayName} (${ArtistService.getRoleTypeFriendlyName(this.props.roleType)})!`;
        }
        else {
            return '';
        }
    }

    getMainImage(params) {
        let roleType = this.props.roleType || 'Artist';
        const imageUrl = this.props.mainVideo ? this.props.mainVideo.ImageUrl : null;
        return imageUtils.getThumbnail(imageUrl, roleType, params || '');
    }

    render() {
        const description = this.getDescription();
        const image = this.getMainImage();
        const mainVideo = this.props.mainVideo;
        const title = this.getTitle();
        const url = `https://www.loudup.com/Video/${this.videoID}`;

        return (
            this.state.videoStatus !== 'FAILED' && this.state.videoStatus !== 'LOADING' ?   
                <div className="main">
                    <MetaTags>
                        <title>{title} - LoudUp</title>
                        <meta id="description" name="description" content={description} />
                        <meta id="og-title" property="og:title" content={title} />
                        <meta id="og-url" property="og:url" content={url} />
                        <meta id="og-description" property="og:description" content={description}/>
                        <meta id="og-image" property="og:image" content={image} />
                        <meta id="twitter-url" name="twitter:url" content={url} />
                        <meta id="twitter-title" name="twitter:title" content={title} />
                        <meta id="twitter-description" name="twitter:description" content={description} />   
                        <meta id="twitter-image" name="twitter:image" content={image} />
                    </MetaTags> 
                    <div className="container">
                        <div className="block-inner">
                            <div className="row">
                                <div className="col-sm-12">
                                    <article id="videopage" className="body-copy">
                                        <header className="why-bgimg track-week-bgimg" style={{backgroundImage: `url(${require('../../images/track-week-bg.jpg')}`}}>
                                            <div className="inner">
                                                <h1>
                                                    <span className="circicon">
                                                        <svg className="icon icon-heart transition">
                                                            <use xlinkHref="#icn-music" />
                                                        </svg>
                                                    </span>
                                                    {this.getTitle(true)}
                                                </h1>
                                                <div className="video-box">
                                                    {
                                                        mainVideo ?
                                                        <VideoItem video={mainVideo} actions={this.props.actions} showShareButton match={this.props.match} showVideoName={false} showCreator={false} roleID={this.props.roleID} />
                                                        :
                                                        <p>No video found</p>
                                                    }
                                                </div>
                                            </div>
                                        </header>
                                        <div className="body-narrow">
                                            <h4>{`MORE VIDEOS FROM ${this.props.roleDisplayName.toUpperCase()}`}</h4>
                                            {
                                                this.props.otherVideos.length ?
                                                    <div className="videos">
                                                    {
                                                        this.props.otherVideos.map(video => 
                                                            <VideoItem key={video.ID} video={video} actions={this.props.actions} showShareButton={false} showVideoName roleID={this.props.roleID} />
                                                        )
                                                    }
                                                    </div>
                                                    :
                                                    <p>Coming soon...</p>
                                            }
                                        </div>
                                    </article>                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : 
                this.state.videoStatus === 'FAILED' ? 
                    <NotFound /> 
                    : 
                    <PageLoading />
        );
    }
}

VideoPage.propTypes = {
    mainVideo: PropTypes.object.isRequired,
    otherVideos: PropTypes.array.isRequired,
    roleID: PropTypes.number.isRequired,
    roleUsername: PropTypes.string.isRequired,
    roleDisplayName: PropTypes.string.isRequired,
    roleType: PropTypes.string,
    user: PropTypes.object,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let roleID = 0;
    let roleUsername = '';
    let roleDisplayName = '';
    let roleType = '';
    let mainVideo = null;
    let otherVideos = [];
    if(state.videos.selectedVideo) {
        mainVideo = state.videos.selectedVideo.Video;
        otherVideos = state.videos.selectedVideo.OtherVideos;
        roleID = state.videos.selectedVideo.RoleID;
        roleUsername = state.videos.selectedVideo.RoleUsername;
        roleDisplayName = state.videos.selectedVideo.RoleDisplayName;
        roleType = state.videos.selectedVideo.RoleType;
    }
    return { 
        user: state.account.user, 
        mainVideo: mainVideo ? { ...mainVideo, RoleDisplayName: roleDisplayName } : null, 
        otherVideos, 
        roleID, 
        roleUsername, 
        roleDisplayName, 
        roleType
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //video actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, videoActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoPage);